<template>
  <div class="basket-wrapper">
  <div class="okno_full" >
               <div class="headnot" :class="{clubs:['club-owner','club-manager'].includes(role)}">
                 <div class="logo-icon" @click="close()">X</div>
                 <img v-if="!['club-owner','club-manager'].includes(role) && activity" :src="client.avatar !== null ? 'https://api.ultimatum.store/images/' + client.avatar : '/img/nophoto.jpg'" @click="oknoUser(true)" class="ava">
                 <div class="catalog" @click="goTocatalog()">КАТАЛОГ</div>
                 <div class="menuBasket" @click="scrolscaner()" v-if="!['club-owner','club-manager'].includes(role)">
                   <div class="tovarod">

                   </div>
                   <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"/><path d="M224,40H184a8,8,0,0,0,0,16h32V88a8,8,0,0,0,16,0V48A8,8,0,0,0,224,40Z"/><path d="M72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Z"/><path d="M224,160a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160Z"/><path d="M32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96Z"/><path d="M80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Z"/><path d="M184,168V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0Z"/><path d="M144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Z"/><path d="M112,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z"/></svg>
                 </div>

               </div>
        <div class="conents_okno" ref="conNT">
        <Suspense>
                <scanner @barcode="getProductBarcode" :format="'ean_13'" style="padding-top: 0px;" v-if="!(sklad1c === '2-Готовая продукция')"/>
        </Suspense>
   <div classs="addNewProduct" v-if="basket.length == 0">
      <p style="padding: 20px;
    text-align: center;">Для оформления заказа<br>добавьте товар из каталога</p>
      <div class="big_button big_button_black" @click="goTocatalog()">Перейти в каталог</div>

   </div>
   <div class="fulls" v-if="basket.length > 0">
     <div class="twoblocks" style="margin-bottom:20px" v-if="sklad1c == '2-Готовая продукция' && ['club-owner','junior-manager'].includes(role)">

      <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: order.pereezd }"
          @click="order.pereezd = !order.pereezd"
        ></div>
        <span class="action-label">Пополнение на склад</span>
      </div>
    </div>


                  
     </div>
   <div class="basketProduct">

       <itembasket v-for="(p,index) of basket" :p="p" :key="p.productid + index + p.timeadd" :in="index" />
       <div class="clubAuth" v-if="['club-owner','club-manager'].includes(role) && !activity && !order.pereezd">
          <div class="big_button big_button_black" style="margin-bottom: 20px;" @click="clubAuth()">Авторизовать покупателя</div>
       </div>
       <div class="clientView" v-if="['club-owner','club-manager'].includes(role) && activity">
         <clientitem
                :firstname = 'client.firstname || "нет"'
                :lastname = 'client.lastname || "нет"'
                :photo = 'client.avatar'
                :phone = 'client.phone !== null ? client.phone : "нет номера"'
                />
      
           <div class="button nocopy" style="grid-column: 1 / -1;
            width: calc(100% - 10px);
            margin: 0;
            color: var(--black);
            background: var(--input);" 
            @click="noclubAuth()">Отменить выбор</div>
       </div>
   </div>
   
   <div v-show="order.nextordergo">
   <div class="fishkiblock">
       <Suspense><fishki /></Suspense>
   </div>
    <div class="fishkiblock" style="margin-top: 20px;" v-if="!['club-owner','club-manager'].includes(role) && !order.pereezd">
      <referral />
   </div>
   <div class="blockDeystvie payment" v-if="!['club-owner','club-manager'].includes(role) && !order.pereezd">
      <p class="section-title">Способ покупки:</p>
      
      <div class="bonus-row">
        <div class="bonus-left">
          <div 
            class="checkbox" 
            :class="{ checked: sposobPokupki.shop }"
            @click="changeFun('shop', sposobPokupki)"
          ></div>
          <span class="bonus-label">В магазине</span>
        </div>
      </div>

      <div class="bonus-row">
        <div class="bonus-left">
          <div 
            class="checkbox" 
            :class="{ checked: sposobPokupki.pickup }"
            @click="changeFun('pickup', sposobPokupki)"
          ></div>
          <span class="bonus-label">Самовывоз из магазина</span>
        </div>
      </div>
   </div>
   <transition name="slimeright">
   <div class="payment" v-if="sposobPokupki.shop && !['club-owner','club-manager'].includes(role) && !order.pereezd">
       <div class="typeoplate" v-for="one of viewPayment">
         <p>{{one.name}}</p>
         <input
         type="tel"
         pattern="[0-9]*"
         @input="addPayment($event,one.type,'focus')" :value="one.price" @focus="addPayment($event,one.type,'focus')" @blur="addPayment($event,one.type,'blur')">
       </div>
   </div>
   </transition>
   <transition name="slimeright">
  <div class="blockDeystvie payment" v-if="sposobPokupki.pickup && !order.pereezd">
    <p class="section-title">Оплата:</p>
    
    <div class="bonus-row">
      <div class="bonus-left">
        <div 
          class="checkbox" 
          :class="{ checked: piakUpPayment['moneta'] }"
          @click="changeFun('bank-card', piakUpPayment)"
        ></div>
        <span class="bonus-label">Банковской картой</span>
      </div>
    </div>

    <div class="bonus-row">
      <div class="bonus-left">
        <div 
          class="checkbox" 
          :class="{ checked: piakUpPayment['dolyamy'] }"
          @click="changeFun('dolyamy', piakUpPayment)"
        ></div>
        <span class="bonus-label">Рассрочкой долями</span>
      </div>
    </div>

    <div class="bonus-row">
      <div class="bonus-left">
        <div 
          class="checkbox" 
          :class="{ checked: piakUpPayment['cash'] }"
          @click="changeFun('cash', piakUpPayment)"
        ></div>
        <span class="bonus-label">Наличными</span>
      </div>
    </div>
  </div>
</transition>
   <div class="good">

     <transition name="list">
           <div class="sdacha" v-if="sdacha > 0">
             <p>СДАЧА КЛИЕНТУ:</p><span>{{ sdacha.toLocaleString('ru-RU') }} ₽</span>
           </div>
     </transition>
   </div>
   <transition name="list">
  <div class="good payment" v-if="viewButtonOplate && !['club-owner','club-manager'].includes(role) && !order.pereezd">
  <div class="actions-block">
    <p class="section-title">Выполнить</p>
    
    <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: ds.all }"
          @click="ds.all = !ds.all"
        ></div>
        <span class="action-label">Оплачен и выдан</span>
      </div>
    </div>

    <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: ds.oplata }"
          @click="ds.oplata = !ds.oplata"
        ></div>
        <span class="action-label">Оплачен</span>
      </div>
    </div>

    <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: ds.vydat }"
          @click="ds.vydat = !ds.vydat"
        ></div>
        <span class="action-label">Выдан</span>
      </div>
    </div>

    <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: ds.sponsor }"
          @click="ds.sponsor = !ds.sponsor"
        ></div>
        <span class="action-label">Спонсорство</span>
      </div>
    </div>

    <div class="action-row">
      <div class="action-left">
        <div 
          class="checkbox" 
          :class="{ checked: ds.save }"
          @click="ds.save = !ds.save"
        ></div>
        <span class="action-label">Сохранить</span>
      </div>
    </div>
  </div>
  
  <transition name="list">
    <div class="big_button big_button_black" @click="goToSale()" style="    margin-top: 20px;" v-if="Object.entries(ds).find(x => x[1] == true)">
      Готово
    </div>
  </transition>
</div>
   </transition>

    <transition name="list">
            <div class="big_button big_button_black" style="margin-top: 20px;" @click="gotoClub()" v-if="['club-owner','junior-manager'].includes(role) && order.pereezd">Оформить</div>
   </transition>
   <transition name="list">
            <div class="big_button big_button_black" style="margin-top: 20px;" @click="goToSale()" v-if="sposobPokupki.pickup && !order.pereezd">Готово</div>
   </transition>
   <transition name="list">
            <div class="big_button big_button_black" style="margin-top: 20px;"  @click="gotoClub()" v-if="['club-owner','club-manager'].includes(role) && !order.pereezd">Перейти к оплате</div>
   </transition>

   </div>

   <p v-show="!order.nextordergo" style="    text-align: center;
    margin: 20px 0px;
    font-weight: 400;
    font-size: 13px;">
     В корзине есть товар с ЧЕСТНЫМ ЗНАКОМ. Отсканируйте его
   </p>

   </div>
</div>
</div>

<transition name="slimeright">

 <modalokno 
        :close="() => infoSamovyvoz.view = false" 
        :text="`Создание заказа`" 
        :button="'Закрыть'" 
        v-if="infoSamovyvoz.view"
      >

   <div class="blockInfoLoadingSamo">
         <div class="blockQrSamo" v-if="infoSamovyvoz.ordernumber !== null && infoSamovyvoz.payment">
            <qrcode-vue :value="`https://ultimatum.store/pmt?id=${infoSamovyvoz.ordernumber}`" :size="200" />
         </div>
          <div class="blockQrSamo" v-else></div>
         <div class="oneInfoSamo">
           <span class="loader" v-if=!infoSamovyvoz.order></span>
           <svg v-else height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg"><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"/></svg>
           <p v-if="infoSamovyvoz.ordernumber == null">Создаем заказ</p>
           <p v-else>Номер заказа {{infoSamovyvoz.ordernumber}}</p>
         </div>
         <div class="oneInfoSamo">
           <span class="loader" v-if=!infoSamovyvoz.payment></span>
           <svg v-else height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg"><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"/></svg><p>Создаем оплату</p>
         </div>
         <div class="oneInfoSamo">
           <span class="loader" v-if=!infoSamovyvoz.dotavka></span>
           <svg v-else height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg"><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"/></svg><p>Создаем самовывоз</p>
         </div>
         <div class="oneInfoSamo">
           <span class="loader" v-if=!infoSamovyvoz.sms></span>
           <svg v-else height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg"><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"/></svg><p>Отправляем смс</p>
         </div>
   </div>
 </modalokno>


   </transition>

    <transition name="opacity">
      <modalokno 
        :close="() => viewIframe = false" 
        :text="`Оплата`" 
        :button="'Закрыть'" 
        v-if="viewIframe"
      >
        <div class="oknaFrame">
                             <img :src="viewSpb">
                      </div>
                       <div class="big_button big_button_black" @click="goToSms()" v-if="['club-owner','club-manager'].includes(role)">Отправить по смс</div>
                       <div class="ozidanie">
                          <div class="noOpl oneInfoSamo">
                            <span class="loader" v-if="clubPaysView"></span>
                            <svg v-else height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg"><path class="cls-1" d="M800,510a30,30,0,1,1,30-30A30,30,0,0,1,800,510Zm-16.986-23.235a3.484,3.484,0,0,1,0-4.9l1.766-1.756a3.185,3.185,0,0,1,4.574.051l3.12,3.237a1.592,1.592,0,0,0,2.311,0l15.9-16.39a3.187,3.187,0,0,1,4.6-.027L817,468.714a3.482,3.482,0,0,1,0,4.846l-21.109,21.451a3.185,3.185,0,0,1-4.552.03Z" id="check" transform="translate(-770 -450)"/></svg>
                            <p>Проверяем статус оплаты</p>
                          </div>
          </div>
      </modalokno>
    </transition>


     <transition name="opacity">
      <modalokno 
        :close="() => closeGoodClub()" 
        :text="`Успешно`" 
        :button="'Закрыть'" 
        v-if="viewClubGood"
      >
         <div class="clubZakaz">
                            <div class="clubZakazGoods">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="11.5" stroke="#333" fill="none" class="circle"/>
                                <path d="M7 12L10.5 15.5L17 9" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" class="check"/>
                            </svg>
                            <p>Оплата прошла успешно<br>Заказ №{{ orderNumbers }} оформлен<br><br><b>Можете выдать товар</b></p>
                            </div>
                        </div>
      </modalokno>
    </transition>


     <transition name="opacity">
      <modalokno 
        :close="() => closeGoodClub()" 
        :text="`Успешно`" 
        :button="'Закрыть'" 
        v-if="viewClubDel"
      >
        <div class="clubZakaz">
                            <div class="clubZakazGoods">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="11.5" stroke="#333" fill="none" class="circle"/>
                                <path d="M7 12L10.5 15.5L17 9" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" class="check"/>
                            </svg>
                            <p>Оплата прошла успешно<br>Заказ №{{ orderNumbers }} с доставкой оформлен<br></p>
                            </div>
                        </div>
      </modalokno>
     </transition>

      <transition name="opacity">
      <modalokno 
        :close="() => closeGoodClub()" 
        :text="`Успешно`" 
        :button="'Закрыть'" 
        v-if="viewPereezd"
      >
        <div class="clubZakaz">
                            <div class="clubZakazGoods">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="11.5" stroke="#333" fill="none" class="circle"/>
                                <path d="M7 12L10.5 15.5L17 9" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" class="check"/>
                            </svg>
                            <p>Заказ на перемещение оформлен</p>
                          
                            </div>
                        </div>
      </modalokno>
     </transition>



   
   </div>
</template>

<script setup>
import itembasket from '@/components/product/itembasket.vue'
import fishki from '@/components/client/fishki.vue'
import scanner from '@/components/general/scanner.vue'
import referral from '@/components/client/referral.vue'
import { basket, order, sendNewOrder, createPayment, deleteBasket, viewbasket, removePayment, clearFishki, createDelivery,forceUpdate,createDeliveryClub } from '@/controlles/basket/basket'
import axios from '@/utils/axios'
import { notSet, setSuc, loading, noloading } from '@/controlles/general'
import { prototypeItem } from '@/controlles/basket/itemPrototype'
import { computed, ref, onMounted, reactive, watch } from 'vue'
import { client, updateLogin, clearUser, oknoUser, activity } from '@/controlles/client'
import { useRouter } from 'vue-router'
import { role, user, sklad1c } from '@/controlles/auth'
import clientitem from '@/components/client/clientitem.vue'
import QrcodeVue from 'qrcode.vue'




const viewIframe = ref(false)
const viewIframeUrl = ref(null)
const viewSpb = ref(null)
const orderNumbers = ref(null)
const viewClubGood = ref(false)
const viewClubDel = ref(false)
const viewPereezd = ref(false)
const r = useRouter()
const ds = reactive({
  oplata: false,
  vydat: false,
  save: false,
  all: false,
  sponsor: false
})

const clubPaysView = ref(true)

const sposobPokupki = reactive({
  shop: true,
  pickup: false
})
const piakUpPayment = reactive({
  'moneta': true,
  dolyamy: false,
  cash: false
})

const infoSamovyvoz = reactive({
  view: false,
  order: false,
  payment: false,
  dotavka: false,
  sms: false,
  ordernumber: null
})
const changeFun = (key, arr) => {
  for (const prop in arr) {
    arr[prop] = false
  }
  arr[key] = true
}

const clubAuth = () => {
  viewbasket.value = false
  r.push('/client/auth')
}

const noclubAuth = () => {
  clearUser()
  clearPrice()
  clearFishki()

}

const goTocatalog = () => {
  if (window.localStream) { window.localStream.getTracks().forEach(track => track.stop()) }
  if (!['club-owner','club-manager'].includes(role.value)) {
    r.push('/catalog/')
    viewbasket.value = false
  } else {
    r.push('/')
    viewbasket.value = false
  }
}

const close = () => {
  if (window.localStream) { window.localStream.getTracks().forEach(track => track.stop()) }
  goTocatalog()
}
const sdacha = ref(0)
const conNT = ref(null)
const viewPayment = computed(() => {
  return order.paymentorder.type.filter(x => x.entity == 'ivanytina')
  if (!order.markingorder) { return order.paymentorder.type.filter(x => x.entity == 'podgornov') }
  return order.paymentorder.type.filter(x => x.entity == 'damanina')
})

const viewButtonOplate = computed(() => {
  if (ds.sponsor) { return true }
  const cash = viewPayment.value.find(x => x.type == 'cash')
  if (cash.activity) {
    if (cash.price > order.paymentorder.payment) {
      sdacha.value = cash.price - order.paymentorder.payment
    } else {
      sdacha.value = 0
    }

    const bank = viewPayment.value.find(x => x.type == 'bank-card')
    if (bank.activity) {
      if ((cash.price + bank.price) > order.paymentorder.payment) {
        sdacha.value = cash.price - (order.paymentorder.payment - bank.price)
      } else {
        sdacha.value = 0
      }
    }
  }
  if (viewPayment.value.reduce((a, x) => a + x.price, 0) == (order.paymentorder.payment + sdacha.value)) {
    return true
  }

  return false
})

const goToSms = async () => {
  try {
    await axios.post('https://api.ultimatum.store/sms/send', { phone: client.value.phone, text: `Перейдите по ссылке для оплаты вашего заказа:https://ultimatum.store/pmt?id=${orderNumbers.value}` })
    notSet('Cообщение отправлено')
  } catch (e) {
    notSet('Ошибка попробуйте еще раз')
  }
}

const proverkaOplatyCall = async (paymentId) => {
  try {
    const response = await axios.post('https://api.ultimatum.store/arm/club/paycheck', {
      id: paymentId
    })

    if (response.status === true) {
      return true
    }
    return false
  } catch (e) {
    console.error('Ошибка при проверке оплаты:', e)
    return false
  }
}

const closeGoodClub = () => {
       
        r.push('/')
        viewClubGood.value = false
        viewClubDel.value = false
        viewbasket.value = false
        viewPereezd.value = true

}

let wakeLock = null;

const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen');
    wakeLock.addEventListener('release', () => {
      console.log('Wake Lock был освобожден');
    });
    
    console.log('Wake Lock активирован');
  } catch (err) {
    console.log('Ошибка активации Wake Lock:', err);
  }
};

const releaseWakeLock = () => {
  if (wakeLock) {
    wakeLock.release();
    wakeLock = null;
    console.log('Wake Lock освобожден');
  }
};

const gotoClub = async () => {
  let checkInterval = null;
  
  try {
    loading.value = true
    
    var channe = 'ultimatum-club'
    if(role.value == 'junior-manager'){
      channe = 'ultimatum-shop'
    }
    order.refferal = user.value.armpoint?.refferal || null
    order.methodcrm = user.value.armpoint?.shop || null
    order.comments = user.value.armpoint.name || 'Не понятный'

    const { orderID, orderNumber } = await sendNewOrder(channe)
    
  

    if(order.pereezd){
      try{
        await createDeliveryClub(orderID,orderNumber)
        sklad1c.value = user.value.armpoint.namesklad
        deleteBasket()
        clearUser()
        viewPereezd.value = true
        return
      }catch(e){
        console.log(e)
        notSet('Ошибка попробуйте еще раз')
        return
      }
    }
     console.log('TWO')
    await requestWakeLock();
    document.addEventListener('visibilitychange', async () => {
      if (wakeLock === null && document.visibilityState === 'visible') {
        await requestWakeLock();
      }
    });
    
    if(sklad1c.value == '2-Готовая продукция'){
      try{
        await createDeliveryClub(orderID,orderNumber)
      }catch(e){
        console.log(e)
      }
    }
   
    viewIframe.value = true

    const viewPayment = await createPayment(orderID, orderNumber, 0, true, 'moneta')
    const response = await fetch(`https://api.ultimatum.store/arm/club/pay?url=${encodeURIComponent(viewPayment.url)}`)
    const data = await response.json()

    viewIframeUrl.value = viewPayment.url
    viewSpb.value = data.qrCodeUrl
    viewIframe.value = true
    orderNumbers.value = orderNumber

     
   
    let attemptCount = 0
    const maxAttempts = 60 
    
    const clearPaymentInterval = () => {
      if (checkInterval) {
        clearInterval(checkInterval)
        checkInterval = null
        releaseWakeLock()
      }
    }
    
    
    checkInterval = setInterval(async () => {
 
      const currentViewIframe = viewIframe.value
      
   
      if (!currentViewIframe) {
        console.log('viewIframe = false, останавливаем проверку оплаты')
        clearPaymentInterval()
        return
      }
      
      attemptCount++
      if (attemptCount > maxAttempts) {
        console.log('Превышено время ожидания оплаты')
        clearPaymentInterval()
        notSet('Время ожидания оплаты истекло')
        viewIframe.value = false 
        return
      }

      try {
        const isPaid = await proverkaOplatyCall(orderID)
        if (isPaid) {
          console.log('Оплата получена, останавливаем проверку')
          clearPaymentInterval()

          if(sklad1c.value !== '2-Готовая продукция'){
            await axios.post('https://api.ultimatum.store/order/sendcrm', { id: orderID })
            await axios.post('https://api.ultimatum.store/bd/updatedocument', { collection: 'order', _id: orderID, set: { $set: { status: 'successfully' } } })
            await axios.post('https://api.ultimatum.store/crm/successfullyshopclub', { id: orderID })
            clubPaysView.value = false
            viewClubGood.value = true
          } else {
            await axios.post('https://api.ultimatum.store/bd/updatedocument', { collection: 'order', _id: orderID, set: { $set: { status: 'send-to-assembling' } } }) 
            clubPaysView.value = false
            viewClubDel.value = true
          }
          
          sklad1c.value = user.value.armpoint.namesklad
          deleteBasket()
          clearUser()
          viewIframe.value = false 
        }
      } catch (error) {
        console.error('Ошибка при проверке оплаты:', error)
      }
    }, 10000)


    const stopWatch = watch(viewIframe, (newValue) => {
      if (!newValue && checkInterval) {
        console.log('watch: viewIframe изменился на false, очищаем интервал')
        clearPaymentInterval()
        stopWatch() 
      }
    })

    loading.value = false
    
  } catch (e) {
    console.log(e)
    if (checkInterval) {
      clearInterval(checkInterval)
      checkInterval = null
    }
    releaseWakeLock()
    viewIframe.value = false 
  }
}


const goToSale = async () => {
  try {
    if (sposobPokupki.shop) { loading.value = true }
    let channe = 'ultimatum-shop'
    if (sposobPokupki.pickup) {
      channe = 'ultimatum-arm'
      noloading.value = true
      infoSamovyvoz.view = true
    }
    const { orderID, orderNumber } = await sendNewOrder(channe)

    if (sposobPokupki.pickup) {
      infoSamovyvoz.ordernumber = orderNumber
      await createDelivery(orderID)
      infoSamovyvoz.order = true
      infoSamovyvoz.dotavka = true
      await createPayment(orderID, orderNumber, 0, true, Object.entries(piakUpPayment).find(x => x[1] == true)[0])
      infoSamovyvoz.payment = true
      if (Object.entries(piakUpPayment).find(x => x[1] == true)[0] !== 'cash') {
        await axios.post('https://api.ultimatum.store/sms/send', { phone: client.value.phone, text: `Перейдите по ссылке для оплаты вашего заказа:https://ultimatum.store/pmt?id=${orderNumber}` })
      }
      infoSamovyvoz.sms = true
      deleteBasket()
      noloading.value = false
      return
    }

    if (ds.oplata) {
      await createPayment(orderID, orderNumber, sdacha.value)
      await axios.post('https://api.ultimatum.store/order/sendcrm', { id: orderID })
    }
    if (ds.vydat) {
      await axios.post('https://api.ultimatum.store/bd/updatedocument', { collection: 'order', _id: orderID, set: { $set: { status: 'successfully' } } })
      await axios.post('https://api.ultimatum.store/crm/successfullyshop', { id: orderID })
      deleteBasket()
      setSuc('Заказ оформлен', 'good')
    }
    if (ds.save) {
      await axios.post('https://api.ultimatum.store/order/sendcrm', { id: orderID })
      deleteBasket()
      setSuc('Заказ сохранен', 'good')
    }
    if (ds.sponsor) {
      await axios.post('https://api.ultimatum.store/bd/updatedocument', { collection: 'order', _id: orderID, set: { $set: { sponsorship: true } } })
      await axios.post('https://api.ultimatum.store/order/sendcrm', { id: orderID })
      await axios.post('https://api.ultimatum.store/bd/updatedocument', { collection: 'order', _id: orderID, set: { $set: { status: 'successfully' } } })
      await axios.post('https://api.ultimatum.store/crm/successfullyshop', { id: orderID })
      deleteBasket()
      setSuc('Заказ оформлен', 'good')
    }

    ds.oplata = false
    ds.vydat = false
    ds.save = false
    ds.sponsor = false
    await updateLogin(client.value.phone, 'phone')
    loading.value = false
  } catch (e) {
    if (sposobPokupki.shop) {
      setSuc('Ошибка оформления', 'error')
    }
    noloading.value = false
    console.log(e)
  }
}

const addPayment = (e, p, type) => {
  sdacha.value = 0
  const val = Number(e.target.value) - sdacha.value
  const pa = viewPayment.value.find(x => x.type == p)
  const summ = viewPayment.value.reduce((a, x) => a + x.price, 0)
  if (val < 0) {
    pa.price = 0
    return
  }
  const patwo = viewPayment.value.find(x => x.type !== p)
  const summmy = order.paymentorder.payment - patwo.price - sdacha.value
  if (type == 'focus') {
    if (summ == 0) {
      pa.price = summmy
      return
    } else {
      if (summmy !== 0) {
        pa.price = summmy
        return
      }
    }
  }
  if (type == 'blur') {
    if (val < 0) {
      pa.price = 0
      return
    }
    if (summmy == 0) {
      pa.price = 0
      return
    }
    pa.price = val - sdacha.value
  }
}

const scrolscaner = () => { conNT.value.scrollIntoView() }




const getProductBarcode = async (barcode) => {
  try {
    const otvet = await axios.post('https://api.ultimatum.store/arm/shop/barcode', { barcode: barcode })
    
    if (otvet.status == 'error') {
      notSet('Штрихкод не распознан')
      return
    }

    if (otvet.spec == null) {
      var pr = new prototypeItem(otvet.product._id, otvet.product.activityspecifications, otvet.product)
      pr.addToCard()
    }

    if (otvet.spec !== null) {
      var pr = new prototypeItem(otvet.product._id, otvet.product.activityspecifications, otvet.product, otvet.spec)
      pr.addToCard()
    }

    notSet('Товар добавлен')
  } catch (e) {
    console.log(e)
  }
}

const clearPrice = () => {
  removePayment()
}

watch(ds, () => {
  if (ds.all) {
    ds.oplata = true
    ds.vydat = true
    ds.save = false
  }

  if (ds.save) {
    ds.oplata = false
    ds.vydat = false
    ds.all = false
  }
  if (ds.oplata) {
    ds.save = false
  }
  if (ds.vydat) {
    ds.save = false
  }
  if (ds.sponsor) {
    ds.oplata = false
    ds.vydat = false
    ds.all = false
    ds.save = false
    clearPrice()
  }
})

watch(basket, () => { clearPrice() })
onMounted(() => {
  clearPrice()
  clearFishki()
})

</script>

<style scoped>
/* Общие переменные и анимации */
@keyframes rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Базовые стили */
.basket-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: var(--bg-primary);
  z-index: 99999;
  overflow: scroll;
}

.conents_okno {
  width: 100%;
  margin-top: -10px;
  padding-bottom: 100px;
}

.fulls {
  width: 94%;
  margin: 0 auto;
      margin-top: 20px;
}

/* Хедер */
.headnot {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  gap: 20px;
  z-index: 9;
}

.catalog {
  color: var(--header-text);
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 1px solid var(--header-text);
}

.ava {
  width: 40px;
  height: 40px;
  border-radius: 100%;
}

.logo-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-black);
  border-radius: 100%;
  color: #ffffff;
  transition: background-color 0.3s;
}

html.dark .logo-icon {
  background: var(--action-btn-bg);
}

/* Иконка меню */
.menuBasket svg {
  width: 30px !important;
}

/* Блоки оплаты и действий */
.payment,
.actions-block,
.blockDeystvie {
  width: 100%;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-light);
  padding: 16px 20px;
  margin-top: 20px;
}

/* Чекбоксы и радио-кнопки */
.checkbox,
.customCheckbox {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-medium);
  background: var(--bg-primary);
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
}

.checkbox.checked,
.customCheckboxActivity {
  background: var(--accent-black);
  border-color: var(--accent-black);
}

.checkbox.checked::after,
.customCheckboxActivity::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--text-inverse);
  font-size: 16px;
  font-weight: 600;
}

/* Заголовки секций */
.section-title {
  margin: 0 0 12px 0;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 500;
}

/* Строки в блоках */
.bonus-row,
.action-row,
.twoblocks {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-light);
}

.twoblocks {
  width: 100%;
  background: var(--tile-icon-bg);
  border: 1px solid var(--tile-border);
  padding: 10px;
  gap: 10px;
}

.twoblocks:last-child,
.bonus-row:last-child,
.action-row:last-child {
  border-bottom: none;
}

.bonus-left,
.action-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.twoblocks p,
.bonus-label,
.action-label {
  margin: 0;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 400;
  text-align: right;
}



.button {
  margin-top: 20px;
}

/* Блок сдачи */
.sdacha {
  display: grid;
  grid-template-columns: 1fr auto;
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 10px;
  background: var(--white);
}

.sdacha p,
.sdacha span {
  font-size: 18px;
  font-weight: 300;
}

.sdacha span {
  color: var(--red);
}

/* Карточка клиента */
.clientView {
  display: grid;
  align-items: center;
  justify-items: right;
  gap: 10px;
  padding: 10px;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
}

/* Стили для полей ввода */
.typeoplate p {
  margin: 0 0 12px 0;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 500;
}

/* Модальные окна загрузки */
.infoForSamovyvoz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: grid;
  align-items: center;
  justify-items: center;
  background: var(--white);
  z-index: 9999999999999;
}

.blockInfoLoadingSamo {
  /* Пустой класс, оставлен для совместимости */
}

.oneInfoSamo,
.noOpl {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    justify-items: center;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}

.oneInfoSamo svg,
.noOpl svg {
  width: 25px;
  height: 25px;
}

/* Анимация загрузки */
.loader {
  width: 25px;
  height: 25px;
  display: inline-block;
  border: 2px solid var(--lightblue);
  border-bottom-color: var(--black);
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

/* SVG иконки */
.cls-1 {
  fill: var(--black);
  fill-rule: evenodd;
}

/* Iframe */
.oknaFrame {
  display: grid;
  align-items: center;
  justify-items: center;
}

.oknaFrame iframe {
  width: 100%;
  height: 100vh;
}

/* Модальные окна подтверждения */
.clubZakaz {
  display: grid;
  align-items: center;
  justify-items: center;
  height: 66vh;
}

.clubZakazGoods {
  display: grid;
  gap: 10px;
  justify-items: center;
  text-align: center;
}

.clubZakazGoods svg {
  width: 50px;
  height: 50px;
}

.clubZakazGoods svg circle,
.clubZakazGoods svg path {
  stroke: var(--green);
}

.clubZakazGoods .button {
  width: 80%;
}

/* Темная тема */
html.dark .actions-block,
html.dark .payment,
html.dark .blockDeystvie {
  background: var(--bg-tertiary);
}

html.dark .checkbox,
html.dark .customCheckbox {
  background: var(--bg-secondary);
  border-color: var(--border-dark);
}

html.dark .checkbox.checked,
html.dark .customCheckboxActivity {
  background: var(--accent-black);
  border-color: var(--accent-black);
}

/* Анимации переходов */
.list-enter-active,
.list-leave-active,
.slimeright-enter-active,
.slimeright-leave-active {
  transition: all var(--transition-normal);
}

.list-enter-from,
.list-leave-to,
.slimeright-enter-from,
.slimeright-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.opacity-enter-active,
.opacity-leave-active {
  transition: opacity var(--transition-normal);
}

.opacity-enter-from,
.opacity-leave-to {
  opacity: 0;
}


.vIps {
  margin: 10px 0;
  color: var(--black);
  font-size: 16px;
  font-weight: 400;
}
.payment .actions-block{
  padding: 0;
}
.clubs{
      grid-template-columns: 1fr auto;
}

.blockQrSamo{
      height: 200px;
    width: 200px;
    background: var(--accent-light-gray);
    margin: 0 auto;
    margin-bottom: 20px;
    border-radius: 20px;
}
</style>